module.exports = __webpack_public_path__ + "img/num4_joy.b82512f7.png";